<template>
  <v-row class="pa-5" v-if="exercise && content">
    <v-col cols="12">
      <h2>Benefits User</h2>
    </v-col>
    <v-col cols="11">
      <results-unit
        :benefits="exercise.doc.benefits"
        :attributes="attributes"
        :showControls="true"
        :showDelete="false"
        :lang="lang"
        @edit="edit"
        @remove="remove"
      />
      <pre>
        {{ exercise }}
      </pre>
    </v-col>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="deleteMode" light>
        <v-card-title>
          Are you sure you want to delete this item?
        </v-card-title>
        <v-card-text class="">
          <v-btn light color="amber mr-5" class="" @click="removeItem"
            >Delete</v-btn
          >
          <v-btn light color="white" class="" @click="cancel">Cancel</v-btn>
        </v-card-text>
      </v-card>
      <v-card light v-else-if="editMode">
        <embed-form
          v-model="item"
          title="Edit an item"
          :showAudience="true"
          :attributes="attributes"
          :dropdown="audiences"
        >
          <v-btn light color="green" class="mt-10 mr-2" @click="editItem"
            >Update</v-btn
          >
          <v-btn light color="white" class="mt-10 mr-2" @click="cancel"
            >Cancel</v-btn
          >
        </embed-form>
      </v-card>
      <v-card light v-else>
        <v-card-text class="">
          <embed-form
            v-model="item"
            title="Add an item"
            :showAudience="true"
            :attributes="attributes"
            :dropdown="audiences"
          >
            <v-btn light color="green" class="mt-10 mt-2 mr-2" @click="addItem"
              >Create Attribute</v-btn
            >
            <v-btn light color="white" class="mt-10 mt-2 mr-2" @click="cancel"
              >Cancel</v-btn
            >
          </embed-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import ResultsUnit from "./ResultsUnit";
import ResultsMixin from "./ResultsMixin";
import EmbedForm from "@/views/user/exercises/attributes/EmbedForm";

export default {
  name: "ResultsBenefitsUser",

  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
    this.getAudiences();
  },

  data() {
    return {
      doc: null,
      content: null,
      exercise: null,
      dialog: false,
      attributes: [],
      audiencesFromExercise: null,
    };
  },
  mixins: [ResultsMixin],
  props: {
    uid: String,
    id: String,
    model: String,
    lang: {
      type: String,
      default: "exercise_benefits_bl",
    },
  },
  components: {
    ResultsUnit,
    EmbedForm,
  },

  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    audiences() {
      if (this.content) {
        return this.content.exercise_benefits.getAudiencesFromExercise
          ? this.audiencesFromExercise
          : this.content.exercise_benefits.step1.dropdown;
      } else {
        return [];
      }
    },
  },

  mounted() {
    this.getAttributes();
  },
  methods: {
    getAudiences() {
      let ref = fb.audienceExCollection.where(
        "pid",
        "==",
        this.$route.params.id
      );
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items && items.length) {
            const body = items[0].doc.matrix;
            this.audiencesFromExercise = [...body.q1, ...body.q2, ...body.q3];
          }
        })
        .catch(function() {});
    },
    saveDoc() {
      console.log("do save");
      const ref = fb.attributesPt2ExCollection.doc(this.exercise.id);
      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid: this.exercise.uid,
          pid: this.exercise.pid,
          doc: this.exercise.doc,
        })
        .then(() => {
          // this.exercise = this.doc;
          console.log("saved element");
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    getAttributes() {
      console.log("get attributes");
      let ref = fb.attributesPt1ExCollection.where("pid", "==", this.id);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let post = docs.data();
          post.doc.attributes.forEach((benefit) => {
            items.push(benefit);
          });
        });
        this.attributes = items;
        this.getExercise();
      });
    },
    getExercise() {
      console.log("get exercise");
      let ref = fb.attributesPt2ExCollection
        .where("pid", "==", this.id)
        .where("uid", "==", this.uid);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        this.exercise = items[0];
      });
    },
  },
};
</script>
